// extracted by mini-css-extract-plugin
export default {"container":"uQ-z","modal":"vQ-z","dimensions":"wQ-z","brandName":"xQ-z","productName":"yQ-z","labelValue":"zQ-z","recipientEmail":"AQ-z","recommendedFit":"BQ-z","hiddenField":"CQ-z"};